export enum AuthState {
  LoggedIn = 'logged_in',
  NotLoggedIn = 'not_logged_in',
}
